// extracted by mini-css-extract-plugin
export default {"titlePreference":"PreferencesHeader_titlePreference__J8Z8T"};